module.exports = __webpack_public_path__ + "static/media/capture-video-mobile.fbe25e89.jpg";